import { Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { TemplateDesignElement } from '../../design-element';
import {
  ChannelUIds,
  CommunicationTemplate,
  CommunicationTemplateViewControl,
  MassNotificationTemplate,
  MessageSettings,
  TemplateViewControlType
} from 'src/app/modules/communications/store/communications';
import { TemplateDesignerService } from 'src/app/modules/communications/services/template-designer.service';
import { MapElementSettings } from './map-control-model';
import produce from 'immer';
import { Dataset } from '@app/modules/core/store/models';
@Component({
    selector: 'topo-template-map-element',
    templateUrl: './map-control.component.html',
    styleUrls: ['./map-control.component.scss'],
    standalone: false
})
export class TemplateDesignMapElement implements OnInit, OnDestroy, TemplateDesignElement {
  @Input() index: number;
  @Input() messageSettings?: MessageSettings;
  @Input() template?: CommunicationTemplate;
  @Input() control?: CommunicationTemplateViewControl;

  @Input() set culture(value: string) {
    this._culture = value;
    if (!this.editMode && !!value) {
      this.render();
    } else if (this.editMode === true && !!value) {
      this.loadSettings();
    }
  }
  _culture: string;
  @Input() orgLanguages: string[];
  @Input() selected: boolean;
  @Input() editable: boolean;
  @Output() settingsChanged = new EventEmitter<{ uId: string; settings: any }>();
  @Output() hideControl = new EventEmitter();
  @Output() showControl = new EventEmitter();

  editMode: boolean;
  private defaultImageSource = 'https://files.topo.ai/images/email/sample-map.png';
  imageSource = this.defaultImageSource;
  title: string;
  imageWidth: string = '800px';
  hideFromPreview: boolean;
  private dataset: Dataset;
  private document: Document;
  private mapUId: string;

  constructor(private translateService: TranslateService, private templateDesignerService: TemplateDesignerService) {}

  ngOnInit(): void {}

  ngOnDestroy(): void {}

  loadSettings(): void {
    this.editMode = true;
    let settings = this.control?.settings as MapElementSettings;
    this.title = this.templateDesignerService.getTranslateText(settings?.title, this._culture);

    if (!!!settings) {
      const control = produce(this.control, draftState => {
        if (!!!draftState.settings) {
          draftState.settings = {
            imageUrl: this.defaultImageSource,
            title: {}
          } as MapElementSettings;
        }
      });

      this.control = control;

      this.imageWidth =
        this.template?.channelUId === ChannelUIds.SlackChannelUId || this.template?.channelUId === ChannelUIds.MicrosoftTeamsChannelUId
          ? '500px'
          : '800px';

      this.settingsChanged.emit({ uId: this.control.uId, settings: control.settings });
    }
  }

  saveSettings(): boolean {
    return true;
  }
  render(): void {
    this.editMode = false;

    if (this.editable === false) {
      this.hideFromPreview = !!!this.document || !!!this.mapUId;
      if (this.hideFromPreview == true) {
        this.hideControl.emit();
      } else {
        this.showControl.emit();
      }
    }

    this.imageWidth =
      this.template?.channelUId === ChannelUIds.SlackChannelUId || this.template?.channelUId === ChannelUIds.MicrosoftTeamsChannelUId
        ? '500px'
        : '800px';

    const settings = this.control?.settings as MapElementSettings;

    this.title = this.templateDesignerService.getTranslateText(settings?.title, this._culture);

    if (!!settings?.imageUrl && this.imageSource !== settings?.imageUrl) {
      this.imageSource = settings.imageUrl;
    }
  }

  edit(): void {}

  setRuntimeData(value: any) {
    if (!this.editMode) {
      if (!!value) {
        const settings = value as MapElementSettings;
        this.imageSource = settings.imageUrl;
        this.render();

        const control = produce(this.control, draftState => {
          if (!!!draftState.settings) {
            draftState.settings = {
              imageUrl: {},
              title: {}
            } as MapElementSettings;
          }
          draftState.settings.imageUrl = settings.imageUrl;
        });

        this.control = control;
        this.settingsChanged.emit({ uId: this.control.uId, settings: control.settings });
      }
      else {
        this.hideFromPreview = true;
      }
    }
  }

  setDocumentContext(dataset: Dataset, document: Document, mapUId: string) {
    this.dataset = dataset;
    this.document = document;
    this.mapUId = mapUId;

    if (!this.editMode) {
      this.render();
    }
  }

  titleChanged(value: any): void {
    const control = produce(this.control, draftState => {
      if (!!!draftState.settings) {
        draftState.settings = {
          imageUrl: {},
          title: {}
        } as MapElementSettings;
      }
      if (!!!draftState.settings.title) {
        draftState.settings.title = {};
      }
      draftState.settings.title[this._culture] = value;

      if (!!!draftState.settings.imageUrl) {
        draftState.settings.imageUrl = this.defaultImageSource;
      }
    });

    this.control = control;

    this.settingsChanged.emit({ uId: this.control.uId, settings: control.settings });
  }
}
